/* eslint-disable */
// <auto-generated>
// Generated by projects/template-ui/scripts/generate-contract-types.ts.
// Source: api/src/Riley.Jms.Application/Schemas/schema-manifest.json.
// </auto-generated>

export interface WorkflowReviewSubmissionRequest {
  decisionRecordId: number;
  expectedETag: string;
  notes?: string | null;
  occurrenceId: number;
  outcome: "approved" | "changes_required";
}

export const WorkflowReviewSubmissionRequestForm = {
  "contract": "WorkflowReviewSubmissionRequest",
  "version": 1,
  "fields": [
    {
      "name": "outcome",
      "type": "string",
      "control": "select",
      "label": "Review outcome",
      "labelToken": "workflow.review.outcome",
      "required": true,
      "nullable": false,
      "lookupDomain": "workflow.review.outcome",
      "options": [
        {
          "value": "approved",
          "label": "Approved",
          "labelToken": "workflow.review.outcome.approved"
        },
        {
          "value": "changes_required",
          "label": "Changes required",
          "labelToken": "workflow.review.outcome.changes_required"
        }
      ],
      "errorCodes": [
        "workflow.review.outcome_invalid"
      ]
    },
    {
      "name": "notes",
      "type": "string",
      "control": "textarea",
      "label": "Review notes",
      "labelToken": "workflow.review.notes",
      "required": false,
      "nullable": true,
      "requiredWhen": {
        "field": "outcome",
        "equals": "changes_required"
      },
      "errorCodes": [
        "workflow.review.reason_required"
      ]
    }
  ]
} as const;
